
import { SelectedSegmentId } from "planning-portal-library/src/lib/core/domain/models/private-location/selected-building-block-id";
import { Mapper } from "../../../../../core/base";
import { SelectedSegmentIdWebEntity } from "./private-location.web-entity.ts/selected-building-block-id-web-entity";

export class SelectedSegmentIdWebRepositoryMapper extends Mapper<SelectedSegmentIdWebEntity, SelectedSegmentId> {

  mapFrom(param: SelectedSegmentIdWebEntity): SelectedSegmentId {
    return {
      id: param.id,
        segment: param.segment,
    };
  }

  mapTo(param: SelectedSegmentId): SelectedSegmentIdWebEntity {
    return {
        id: param.id,
        segment: param.segment,
    };
  }

}
